import {
  AlarmClockMinus,
  AlarmClockPlus,
  PackageMinus,
  PackagePlus,
  Route,
  SquareCheckBig,
} from 'lucide-react';
import { LucideIcon } from 'lucide-react';

import { PendingEmail } from 'types/PendingOutboxEmail';

export enum MilestoneKey {
  DISPATCH = 'dispatch',
  PICKUP = 'pickup',
  LOADED = 'loaded',
  IN_TRANSIT = 'inTransit',
  DROPOFF = 'dropoff',
  UNLOADED = 'unloaded',
}

const HEADER_TEXT_MAP: Record<MilestoneKey, string> = {
  [MilestoneKey.DISPATCH]: 'Confirm dispatch',
  [MilestoneKey.PICKUP]: 'Confirm at pickup appt',
  [MilestoneKey.LOADED]: 'Confirm loaded',
  [MilestoneKey.IN_TRANSIT]: 'Confirm In-Transit ETA',
  [MilestoneKey.DROPOFF]: 'Confirm at dropoff appt',
  [MilestoneKey.UNLOADED]: 'Confirm unloaded',
};

const MILESTONE_ICON_MAP: Record<MilestoneKey, LucideIcon> = {
  [MilestoneKey.DISPATCH]: SquareCheckBig,
  [MilestoneKey.PICKUP]: AlarmClockPlus,
  [MilestoneKey.LOADED]: PackagePlus,
  [MilestoneKey.IN_TRANSIT]: Route,
  [MilestoneKey.DROPOFF]: AlarmClockMinus,
  [MilestoneKey.UNLOADED]: PackageMinus,
};

export const getHeaderText = (key: string) => {
  const milestoneKey = key as MilestoneKey;
  return HEADER_TEXT_MAP[milestoneKey] ?? key;
};

export const getMilestoneIcon = (
  key: string,
  pendingEmails: PendingEmail[]
) => {
  const iconColor = pendingEmails.length === 0 ? '#9CA3AF' : '#E92C2C';
  const milestoneKey = key as MilestoneKey;
  const IconComponent = MILESTONE_ICON_MAP[milestoneKey];

  if (!IconComponent) {
    return null;
  }

  return <IconComponent color={iconColor} size={'sm'} strokeWidth={1} />;
};
